import { appeler } from './api.js';

/**
 * LES EXECUTIONS D UN PROJET [29-F].
 *
 * FACADE PROPRE, non un ajout a `projets.ts` : l execution est une ressource
 * du domaine `execution`, avec son cycle et sa pagination par curseur.
 *
 * SNAKE_CASE conserve jusque dans le type : `/locataires/` porte cette
 * convention [dette 53]. Le contrat serveur est lu tel quel.
 *
 * LES CHAMPS DE L API, PAS UN DE PLUS. Le serveur en rend neuf ; cet index
 * en type cinq -- ceux que la liste affiche. Le jour ou un ecran demande
 * `arret_code` ou `nb_elements_traites`, il les ajoutera ICI, en sachant
 * pourquoi. C est un INDEX, pas un export du modele.
 */
export interface LigneExecution {
  readonly id: string;
  readonly automatisation: { readonly id: string; readonly nom: string };
  readonly etat: string;
  readonly demarre_le: string;
  readonly termine_le: string | null;
}

/**
 * LA VUE SITUEE. Le perimetre est prouve par le MOTEUR : `exigerProjet`
 * resout le projet dans le locataire avant toute lecture. L appelant ne
 * filtre rien, et ne recoit rien qu il n ait le droit de voir.
 *
 * `curseur_suivant` est rendu tel quel, sans etre consomme aujourd hui :
 * l ecran affiche la premiere page. Le masquer ici obligerait a rouvrir la
 * facade le jour ou la pagination devient visible.
 */
export async function listerExecutionsDuProjet(
  espace: string, projet: string,
): Promise<{ readonly executions: readonly LigneExecution[];
             readonly curseur_suivant: string | null }> {
  return appeler<{ executions: readonly LigneExecution[];
                   curseur_suivant: string | null }>(
    'GET', `/locataires/${encodeURIComponent(espace)}`
      + `/projets/${encodeURIComponent(projet)}/executions`);
}
